// Encode email using character codes to hide from spam harvesters
export const obfuscateEmail = (email) => {
  return email.split('').map(char => `&#${char.charCodeAt(0)};`).join('');
};

// Decode obfuscated email (for display)
export const decodeEmail = (encodedEmail) => {
  const parser = new DOMParser();
  return parser.parseFromString(`<!doctype html><body>${encodedEmail}`, 'text/html').body.textContent;
};

// Protected email addresses
export const EMAILS = {
  INFO: 'info@kodefactor.io',
  CAREERS: 'careers@kodefactor.io',
  SALES: 'sales@kodefactor.io',
};
